import Question from "../types/Question.interface";
import Statement from "../types/Statement.interface";
import InitialValues from "../types/InitialValues.interface";
import { State } from "../types/BaseContext.types";
import { FormikErrors } from "formik";

export const createInitialValues = (
  question: Question,
  baseState: State
): InitialValues => {
  const { statements, _id: questionId } = question;
  const initialValues: InitialValues = {};

  statements.forEach((statement: Statement) => {
    const { type, _id: statementId } = statement;

    let defaultValue;

    switch (type) {
      case "checkbox":
        defaultValue = [];
        break;

      case "text":
      case "number":
        defaultValue = {
          id: "",
          value: "",
        };
        break;

      case "radio":
        defaultValue = {
          id: "",
          value: "",
        };
        break;

      default:
        defaultValue = {};
        break;
    }

    initialValues[statementId] =
      baseState[questionId]?.[statementId] || defaultValue;
  });

  return initialValues;
};

export const scrollToFirstError = (errors: FormikErrors<InitialValues>) => {
  const firstKey = Object.keys(errors)[0];
  const selector = `[name="${firstKey}"]`;
  const domElement = document.querySelector(selector);

  if (domElement) {
    /**
     * TODO: DOMNODE.closest() does not work in IE <= 11
     *
     * Use something like this: https://stackoverflow.com/a/42873108
     */
    const fieldsetElement = domElement?.closest("fieldset");
    fieldsetElement?.scrollIntoView({ block: "start", behavior: "smooth" });
  }
};
